module.exports = __webpack_public_path__ + "img/Bulb_MV.c0c2f872.svg";